var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect } from 'react';
export var ThemeContext = createContext({
    theme: 'light',
    toggleTheme: function () { },
});
export var ThemeProvider = function (_a) {
    var children = _a.children;
    // Get theme preference from localStorage or use system preference
    var getInitialTheme = function () {
        var savedTheme = localStorage.getItem('theme');
        if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
            return savedTheme;
        }
        // Check system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light';
    };
    var _b = useState(getInitialTheme), theme = _b[0], setTheme = _b[1];
    // Toggle between light and dark themes
    var toggleTheme = function () {
        setTheme(function (prevTheme) { return (prevTheme === 'light' ? 'dark' : 'light'); });
    };
    // Update localStorage when theme changes
    useEffect(function () {
        localStorage.setItem('theme', theme);
        // Apply theme classes to document
        var htmlElement = document.documentElement;
        var bodyElement = document.body;
        // Remove existing theme classes
        htmlElement.classList.remove('dark', 'light');
        bodyElement.classList.remove('theme-dark', 'theme-light');
        // Add new theme classes
        htmlElement.classList.add(theme === 'dark' ? 'dark' : 'light');
        bodyElement.classList.add("theme-".concat(theme));
    }, [theme]);
    return (_jsx(ThemeContext.Provider, __assign({ value: { theme: theme, toggleTheme: toggleTheme } }, { children: children })));
};
